/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 15:12:36
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-10-10 13:56:24
 */
import common from "@/common/common";
import { routerFor } from "@/common/other";
import configData from "@/config/config";
import recursionRouter from "@/router/add-router";
import logonRoutes from "@/router/login";
import router from "@/router/index";
import { getPermission } from "@/api/api-basic";
import { getOprInfo } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
const state = {
    isLogin: false,
    winOnresize: false,
    isGetRouter: false,
    keepAliveList: [],
    goRouter: [],
    goRouterList: [],
    toData: {},
    routerList: [],
    routerMainIndex: {},
    userInfo: {},
    userType: "oper",
    menuIndex: 0,
    menuList: [],
    pageLoading: false,
    operInfo: {},
    footText: "",
    otherPageAuto: {},
    userAnalysisForm: {},
};
const getters = {};
const mutations = {
    /**
     * 是否登录
     * @param state
     * @param status 状态
     */
    SET_ISLOGIN(state, status) {
        state.isLogin = status;
    },
    /**
     * 窗口变化是改变
     * @param state
     */
    SET_WINONRESIZE(state) {
        state.winOnresize = !state.winOnresize;
    },
    /**
     * 动态添加路由
     * @param {*} state
     * @param {object[]} list 后台返回的菜单
     */
    SET_ROUTERLIST(state, list) {
        const routerList = recursionRouter(list); // eslint-disable-line
        // console.log(routerList);
        //动态添加路由
        routerList.forEach((res) => {
            router.addRoute(res);
        });
        state.routerList = routerList;
    },
    /**
     * 动态添加注册页面路由
     * @param {*} state
     * @param {object[]} list 后台返回的菜单
     */
    SET_LOGIN_ROUTERLIST() {
        //动态添加路由
        logonRoutes.forEach((res) => {
            router.addRoute(res);
        });
    },
    /**
     * 路由变化时执行,保存经过的路由,最多9个,用在tag标签和缓存路由
     * @param {*} state
     * @param {objAny} data 经过路由的数据
     */
    SET_GOROUTER(state, data) {
        let isPush = true;
        state.goRouter.map((item) => {
            if (item.url == data.url) {
                item.fullPath = data.fullPath;
                isPush = false;
            }
        });
        if (isPush) {
            if (state.goRouter.length >= 7) {
                state.goRouter.splice(0, 1);
                state.keepAliveList.splice(0, 1);
            }
            state.goRouter.push(data);
            state.keepAliveList.push(data.componentsName);
        }
        state.goRouterList.push(data);
        if (state.goRouterList.length >= 7) {
            state.goRouterList.splice(0, 1);
        }
    },
    /**
     *  删除路由 tag
     * @param {*} state
     * @param {number} index
     */
    UP_GOROUTER(state, index) {
        state.goRouter.splice(index, 1);
        state.keepAliveList.splice(index, 1);
    },
    /**
     * 根据URL删除路由
     * @param {*} state
     * @param {string} url
     */
    urlRemoveRouter(state, url) {
        let index = -1;
        state.goRouter.map((item, i) => {
            if (item.url == url) {
                index = i;
            }
        });
        if (index != -1) {
            state.goRouter.splice(index, 1);
            state.keepAliveList.splice(index, 1);
        }
    },
    /**
     * 当前的路由
     * @param {*} state
     * @param {objAny} data
     */
    SET_TODATE(state, data) {
        state.toData = data;
    },
    /*
     * 是否经过路由初始化
     * @param {*} state
     * @param {boolean} status
     */
    SET_ISGETROUTER(state, status) {
        state.isGetRouter = status;
    },
    /**
     * 登录信息
     * @param {*} state
     * @param {objAny} data
     */
    SET_USERINFO(state, data) {
        state.userInfo = data;
        if (data.roleType == 6) {
            state.userType = "admin";
        }
        else if (data.roleType == 2 || data.roleType == 3) {
            state.userType = "oper";
        }
        else if (data.roleType == 4) {
            state.userType = "mch";
        }
    },
    /**
     * 登录信息
     * @param {*} state
     * @param {objAny} data
     */
    SET_MENULIST(state, list) {
        state.menuList = list;
    },
    SET_PAGELOADING(state, status) {
        state.pageLoading = status;
    },
    /**
     *
     * @param state 保存运营商信息
     * @param data
     */
    SET_OPERINFO(state, data) {
        state.operInfo = data;
    },
    /**
     * 保存备案信息
     * @param state
     * @param str
     */
    SET_FOOTTEXT(state, str) {
        state.footText = str;
    },
    /**
     * 保存头部菜单的图标操作是否有权限，这个权限在权限处理里找到对应的权限才显示对应的操作图标
     * @param state
     * @param key
     */
    SET_OTHERPAGEAUTO(state, key) {
        state.otherPageAuto[key] = true;
    },
    SET_USERANALYSISFORM(state, data) {
        state.userAnalysisForm = data;
    },
};
const forMenuChild = function (list) {
    let str = "";
    list.map((item, index) => {
        if (index == 0) {
            if (item.children && item.children.length > 0) {
                str = forMenuChild(item.children);
            }
            else {
                str = item.url;
            }
        }
    });
    return str;
};
const actions = {
    /**
     * 路由初始化
     * @param {*} { commit, state }
     * @param {objAny} obj
     */
    async getRouter({ commit }, obj) {
        const loginData = common.get("loginData");
        const win = window;
        // 已登录的账号
        if (loginData) {
            state.isGetRouter = true;
            commit("SET_USERINFO", loginData);
            let toUrl = obj.to.fullPath;
            // 获取权限接口
            const retMemu = await getPermission({ roleId: loginData.rolePkId });
            if (retMemu.status === configData.apiStatus) {
                const data = retMemu.data[0] ? retMemu.data[0].children : []; // 找到运营商的权限菜单
                // 登录进来，处理一个权限的数据
                const routerData = routerFor(data);
                // console.log(routerData);
                commit("SET_MENULIST", routerData.arr); // 保存菜单
                commit("SET_ROUTERLIST", routerData.routerAutoArr); // 保存并动态添加路由
                if (toUrl == "/") {
                    if (routerData.itemData) {
                        toUrl = routerData.itemData.url;
                    }
                    else {
                        toUrl = forMenuChild(data);
                    }
                }
            }
            commit("SET_ISLOGIN", true);
            // 如果角色是运营商或者运营商自定义角色，就请求一下运营商信息的接口，并保存起来，上帝角色不用走这
            if (loginData.roleType == 2 || loginData.roleType == 3) {
                const ret = await getOprInfo({});
                if (ret.status === configData.apiStatus) {
                    // operInfo
                    const info = ret.data[0] || {};
                    if (info.websiteRecordInfo) {
                        commit("SET_FOOTTEXT", info.websiteRecordInfo);
                    }
                    else {
                        const footText = i18n.locale == "en-US"
                            ? configData.footTextEnglish
                            : configData.footText;
                        commit("SET_FOOTTEXT", footText);
                    }
                    commit("SET_OPERINFO", info);
                    if (info.oprSystemName) {
                        win.document.title =
                            "【" + info.oprSystemName + "】" + i18n.t("websiteTitle");
                    }
                    const imgUrl = info.imageUrl;
                    const link = document.querySelectorAll("link[rel*='icon']");
                    if (link) {
                        link[0]["href"] = configData.fileImg + imgUrl;
                    }
                }
            }
            obj.next &&
                obj.next({
                    path: toUrl,
                });
        }
        else {
            // 新注册没有填写资料的账号
            const loginDataRegister = common.get("loginDataRegister");
            if (loginDataRegister) {
                commit("SET_USERINFO", loginDataRegister);
                commit("SET_ISGETROUTER", true);
                commit("SET_LOGIN_ROUTERLIST"); // 添加注册资料路由
                // commit("SET_ISLOGIN", true);
                const toUrl = obj.to.fullPath;
                obj.next &&
                    obj.next({
                        path: toUrl,
                    });
            }
            else {
                commit("SET_ISGETROUTER", false);
                commit("SET_ISLOGIN", false);
                if (configData.loginUrl && configData.loginUrl != "") {
                    win.location.href = configData.loginUrl;
                }
                else {
                    obj.next({
                        path: "/login",
                    });
                }
            }
        }
        win.onresize = common.debounce(() => {
            commit("SET_WINONRESIZE", true);
        }, 200);
    },
    async getOprInfo({ commit }) {
        const ret = await getOprInfo({});
        if (ret.status === configData.apiStatus) {
            commit("SET_OPERINFO", ret.data[0]);
        }
    },
};
export default {
    state,
    mutations,
    actions,
    getters,
};
